const staticProductList = [
    'Optimize',
    'Automate',
    'Manage',
    'Monitor',
    'Plan',
    'UserAdmin'
  ];
  
  export default staticProductList;